import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/styles/fes-icons.css'
import 'vuetify/styles';
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { fr } from 'vuetify/locale'

const colors = {
  action0: '#000000FF',
  action10: '#311402FF',
  action100: '#FFFFFFFF',
  action20: '#612705FF',
  action30: '#923B07FF',
  action40: '#C24E0AFF',
  action50: '#F3620CFF',
  action60: '#F5813DFF',
  action70: '#F8A16DFF',
  action80: '#FAC09EFF',
  action90: '#FDE0CEFF',
  error0: '#000000FF',
  error10: '#311202FF',
  error100: '#FFFFFFFF',
  error20: '#612405FF',
  error30: '#923507FF',
  error40: '#C2470AFF',
  error50: '#F3590CFF',
  error60: '#EA6348FF',
  error70: '#EF8A76FF',
  error80: '#F4B1A4FF',
  error90: '#FAD8D1FF',
  grey0: '#000000FF',
  grey10: '#171A1CFF',
  grey100: '#FFFFFFFF',
  grey20: '#2D3539FF',
  grey30: '#444F55FF',
  grey40: '#5B6A71FF',
  grey50: '#71848EFF',
  grey60: '#8E9DA4FF',
  grey70: '#AAB5BBFF',
  grey80: '#C6CED2FF',
  grey90: '#E3E6E8FF',
  grey95: '#F1F3F4FF',
  grey97: '#F7F8F8FF',
  information0: '#000000FF',
  information10: '#021E30FF',
  information100: '#FFFFFFFF',
  information20: '#053B61FF',
  information30: '#075991FF',
  information40: '#0A77C2FF',
  information50: '#0C95F2FF',
  information60: '#3DAAF5FF',
  information70: '#6DBFF7FF',
  information80: '#9ED4FAFF',
  information90: '#CEEAFCFF',
  primary0: '#000000FF',
  primary10: '#2D0606FF',
  primary100: '#FFFFFFFF',
  primary20: '#5B0C0BFF',
  primary30: '#881311FF',
  primary40: '#B61916FF',
  primary50: '#E31F1CFF',
  primary60: '#E94C49FF',
  primary70: '#EE7977FF',
  primary80: '#F4A5A4FF',
  primary90: '#F9D2D2FF',
  primary95: '#FCE8E8FF',
  secondary0: '#000000FF',
  secondary10: '#09292AFF',
  secondary100: '#FFFFFFFF',
  secondary20: '#135253FF',
  secondary30: '#1C7A7DFF',
  secondary40: '#25A3A7FF',
  secondary50: '#2ECCD1FF',
  secondary60: '#58D6DAFF',
  secondary70: '#82E0E3FF',
  secondary80: '#ACEBECFF',
  secondary90: '#D5F5F6FF',
  secondary95: '#EAFAFBFF',
  secondary98: '#F6FDFDFF',
  success0: '#000000FF',
  success10: '#202E05FF',
  success100: '#FFFFFFFF',
  success20: '#3F5B0BFF',
  success30: '#5F8910FF',
  success40: '#7EB715FF',
  success50: '#9EE41BFF',
  success60: '#B1EA48FF',
  success70: '#C5EF76FF',
  success80: '#D8F4A4FF',
  success90: '#ECFAD1FF',
  white: '#FFFFFFFF',
}

export default createVuetify({ 
  ssr: true,
  locale: {
    locale: 'fr',
    fallback: 'fr',
    messages: { fr },
  },
  components: {
    ...components,
    ...labsComponents,
  },
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa,
    },
  },
  directives,
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 1326,
      lg: 1280,
    },
  },
  theme: {
    defaultTheme: 'CiTheme',
    themes: {
      CiTheme: {
        dark: false,
        colors
      },
    },
  },

});
